module.exports = __webpack_public_path__ + "img/vn.e50bfd95.svg";